import { ReferenceSystemGraphicProperties } from '../3D/graphic-properties/reference-system-graphic-properties.model';
import { Point3d } from '../point3d.model';
import { ReferenceSystemType } from './reference-system-type.enum';

export class ReferenceSystem {
  title: string;
  id?: number;
  internalId: number;

  type: ReferenceSystemType;
  structureOfAttachment: number;
  nodeOfAttachment: number;

  definedByUser: boolean;
  structureOfDefinition: number;
  elementOfDefinitionIndex: number;

  coordinates: Point3d;
  rotation: Point3d;

  graphicProperties?: ReferenceSystemGraphicProperties;
  needsUpdate?: boolean;

  constructor() {}
}
